import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { JispPayPlacesBase } from '../../../../../app.retailer.common/controllers/jispPayPlacesBase.controller';
import { IRetailerRootScope } from '../../../core/models';
import { JispPayService } from '../../jispPay.service';
import { IStoreJispPayListItem } from '../../models';
import { ICompanyInformation } from '../../models/ICompanyInformation';

class JispPayPlacesController extends JispPayPlacesBase {
    public static $inject = [
        'notificationService',
        '$rootScope',
        'jispPayService',
        '$scope',
        '$translate',
        '$uibModal'
    ];

    public viewport = {
        width: $(window).width(),
        height: $(window).height(),
        scrollTop: 0
    };

    public model: ICompanyInformation;

    constructor(
        private notificationService: NotificationService,
        public $rootScope: IRetailerRootScope,
        private jispPayService: JispPayService,
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        public $uibModal: ng.ui.bootstrap.IModalService
    ) {
        super($translate);
        $(window).resize(() => {
            this.viewport.width = $(window).width();
            this.viewport.height = $(window).height();
            $scope.$apply();
        });

        $(window).scroll(() => {
            this.viewport.scrollTop = $(document).scrollTop();
            $scope.$apply();
        });
        this.init();
    }

    public $onInit() {
        this.getCompanyInfo();
    }

    public async getCompanyInfo() {
        this.waiting = true;
        try {
            this.model = await this.jispPayService.getCompanyInfo();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        } finally {
            this.notificationService.clearAll();
            this.waiting = false;
        }
    }

    public placeEnabled = async (place: IStoreJispPayListItem) => {
        if (place.IsRefundPasswordExist) {
            this.waiting = true;
            this.notificationService.showWaitingMessage();
            try {
                await this.jispPayService.setJispPayEnable({
                    Enable: place.Enabled,
                    StoreID: place.ID
                });
                this.notificationService.showSuccessMessage();
                this.edit.isOpenEdit = false;
            } catch (error) {
                this.notificationService.showErrorMessage(error);
            }
        } else {
            this.placeEdit(place, true);
        }
        this.waiting = false;
    }

    public save = async (place: IStoreJispPayListItem) => {
        if (!this.isValidEditModel(place)) {
            return;
        }
        try {
            const password = this.edit.model.RefundPassword;
            this.edit.model.VerificationPassword = await this.jispPayService.passwordConfirmation(
                place.ID
            );
            this.waiting = true;
            this.notificationService.showWaitingMessage();
            this.edit.model.RefundPassword = password;
            await this.jispPayService.setPlace(place.ID, this.edit.model);
            this.updateAfterSave(place);
            this.notificationService.clearAll();
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClick(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
        this.waiting = false;
    }

    public openSetInfoDialog = async () => {
        const operationResult: any = await this.$uibModal.open({
            component: 'paymentSettingsPopUp',
            resolve: {
                currentCompanyInfo: () => angular.copy(this.model)
            },
            size: 'md',
            backdrop: 'static'
        }).result;
        if (operationResult === 'ok') {
            this.getCompanyInfo();
        }
    }

    private init = async () => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            this.jispPayMerchants = await this.jispPayService.getJispPayMerchants();
            this.getPlaces();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private getPlaces = async () => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const pagingResult = await this.jispPayService.getPlaces();
            this.places = pagingResult.Items as IStoreJispPayListItem[];
            this.isPlacesAny = pagingResult.Total > 0;
            _.forEach(this.places, (place) => {
                const merchant = _.find(this.jispPayMerchants, (singleMerchant) => {
                    return singleMerchant.ID === place.JispPayMerchantID;
                });
                place.merchantID = merchant ? merchant.MerchantID : '';
            });
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
        this.edit.isOpenEdit = false;
    }

    private updateAfterSave(place: IStoreJispPayListItem) {
        this.edit.model.VerificationPassword = null;
        place.merchantID = this.edit.model.selectedMerchant ? this.edit.model.selectedMerchant.MerchantID : null;
        place.JispPayMerchantID = this.edit.model.selectedMerchant ? this.edit.model.selectedMerchant.ID : null;
        place.refundPassword = this.edit.model.RefundPassword;
        this.edit.isOpenEdit = false;
        place.isOpenEdit = false;
    }
}

angular.module('naut').component('jispPayPlaces', {
    template: require('./jisppayPlaces.html'),
    controller: JispPayPlacesController,
    controllerAs: 'vm'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/jisppayPlaces/jisppayPlaces.component.ts